import * as React from 'react';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import DebouncedInput from '../TableHeader/DebouncedInput';

export const DebouncedTextFilterCell = React.memo(
  (props: GridFilterCellProps) => {
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      props.onChange({
        value: e.target.value,
        operator: 'contains',
        syntheticEvent: {
          ...e,
          currentTarget: { id: `filter-${props.field}` },
        },
      });
    };

    return (
      <div>
        <DebouncedInput
          id={`filter-${props.field}`}
          value={props.value}
          onChangeValue={onChange}
          debounceTime={1000}
          enableClear
        />
      </div>
    );
  }
);
